import { saveAs } from 'file-saver';
import { firefoxWorkaroundPdfDownload, hasValue } from '../helpers';
import * as clipboard from '../helpers/clipboard';
import { getSenderIdentity } from '../helpers/messages';
import { hasAckDecReactions } from './message_group_reactions';
import { hasMetaInfo } from './message_meta';
import { hasEmojiReactions } from './message_emoji_reactions';
export default [
    'BrowserService',
    'LogService',
    'MessageService',
    'ReceiverService',
    'WebClientService',
    '$mdDialog',
    '$mdToast',
    '$translate',
    '$rootScope',
    function (browserService, logService, messageService, receiverService, webClientService, $mdDialog, $mdToast, $translate, $rootScope) {
        const log = logService.getLogger('Message-C');
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                type: '=eeeType',
                receiver: '=eeeReceiver',
                message: '=eeeMessage',
                resolution: '=?eeeResolution',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.browserInfo = browserService.getBrowser();
                    this.$onInit = function () {
                        if (this.resolution == null) {
                            this.resolution = 'low';
                        }
                        this.contact = webClientService.contacts.get(getSenderIdentity(this.message, webClientService.me.id));
                        this.isStatusMessage = this.message.isStatus;
                        this.isContactMessage = !this.message.isStatus
                            && webClientService.contacts.has(getSenderIdentity(this.message, webClientService.me.id));
                        this.isGroup = this.type === 'group';
                        this.isContact = this.type === 'contact';
                        this.isBusinessReceiver = receiverService.isBusinessContact(this.receiver);
                        this.isEdited = hasValue(this.message.lastEditedAt);
                        this.showName = !this.message.isOutbox && this.isGroup;
                        this.showAvatar = this.showName;
                        this.showText = this.message.type === 'text' || this.message.caption;
                        this.showMedia = this.message.type !== 'text';
                        this.showState = messageService.showStatusIcon(this.message, this.receiver);
                        this.showGroupReactions =
                            !webClientService.appCapabilities.emojiReactions && this.isGroup
                                && webClientService.appCapabilities.groupReactions && hasAckDecReactions(this.message);
                        this.showEmojiReactions = webClientService.appCapabilities.emojiReactions && hasEmojiReactions(this.message);
                        this.hasMetaInfo = hasMetaInfo(this.message);
                        this.showQuote = this.message.quote !== undefined;
                        this.showVoipInfo = this.message.type === 'voipStatus';
                        this.access = messageService.getAccess(this.message, this.receiver, webClientService.appCapabilities, webClientService.me.id);
                        this.ack = (ack) => {
                            webClientService.ackMessage(this.receiver, this.message, ack);
                        };
                        this.quote = () => {
                            webClientService.setQuote(this.receiver, this.message);
                        };
                        this.delete = (ev) => {
                            const confirm = $mdDialog.confirm()
                                .title($translate.instant('messenger.CONFIRM_DELETE_TITLE'))
                                .textContent($translate.instant('common.ARE_YOU_SURE'))
                                .targetEvent(ev)
                                .ok($translate.instant('common.YES'))
                                .cancel($translate.instant('common.CANCEL'));
                            $mdDialog.show(confirm).then((result) => {
                                webClientService.deleteMessage(this.receiver, this.message);
                            }, () => { });
                        };
                        this.copyToClipboard = (ev) => {
                            const text = messageService.getQuoteText(this.message);
                            if (text === null) {
                                return;
                            }
                            let toastString = 'messenger.COPIED';
                            try {
                                clipboard.copyString(text, this.browserInfo.isSafari());
                            }
                            catch (error) {
                                log.warn('Could not copy text to clipboard:', error);
                                toastString = 'messenger.COPY_ERROR';
                            }
                            const toast = $mdToast.simple()
                                .textContent($translate.instant(toastString))
                                .position('bottom center');
                            $mdToast.show(toast);
                        };
                        this.download = (ev) => {
                            this.downloading = true;
                            webClientService.requestBlob(this.message.id, this.receiver)
                                .then((blobInfo) => {
                                $rootScope.$apply(() => {
                                    this.downloading = false;
                                    switch (this.message.type) {
                                        case 'image':
                                        case 'video':
                                        case 'file':
                                        case 'audio':
                                            saveAs(new Blob([blobInfo.buffer], { type: firefoxWorkaroundPdfDownload(blobInfo.mimetype) }), blobInfo.filename);
                                            break;
                                        default:
                                            log.warn('Ignored download request for message type', this.message.type);
                                    }
                                });
                            })
                                .catch((error) => {
                                log.error(`Error downloading blob: ${error}`);
                                this.downloading = false;
                            });
                        };
                        this.isDownloading = () => {
                            return this.downloading;
                        };
                        this.showHistory = (ev) => {
                            const getEvents = () => this.message.events;
                            const getMessageId = () => this.message.id;
                            $mdDialog.show({
                                controllerAs: 'ctrl',
                                controller: function () {
                                    this.getEvents = getEvents;
                                    this.getMessageId = getMessageId;
                                    this.close = () => {
                                        $mdDialog.hide();
                                    };
                                },
                                template: `
                                <md-dialog class="message-history-dialog" translate-attr="{'aria-label': 'messenger.MSG_HISTORY'}">
                                    <form ng-cloak>
                                        <md-toolbar>
                                            <div class="md-toolbar-tools">
                                                <h2 translate>messenger.MSG_HISTORY</h2>
                                            </div>
                                        </md-toolbar>
                                        <md-dialog-content>
                                            <p><span class="message-id">Message ID:</span> {{ ctrl.getMessageId() }}</p>
                                            <p ng-repeat="event in ctrl.getEvents()">
                                                <span class="event-type" ng-if="event.type === 'created'" translate>messenger.MSG_HISTORY_CREATED</span>
                                                <span class="event-type" ng-if="event.type === 'sent'" translate>messenger.MSG_HISTORY_SENT</span>
                                                <span class="event-type" ng-if="event.type === 'delivered'" translate>messenger.MSG_HISTORY_DELIVERED</span>
                                                <span class="event-type" ng-if="event.type === 'read'" translate>messenger.MSG_HISTORY_READ</span>
                                                <span class="event-type" ng-if="event.type === 'acked'" translate>messenger.MSG_HISTORY_ACKED</span>
                                                <span class="event-type" ng-if="event.type === 'modified'" translate>messenger.MSG_HISTORY_MODIFIED</span>
                                                {{ event.date | unixToTimestring:true }}
                                            </p>
                                        </md-dialog-content>
                                        <md-dialog-actions layout="row" >
                                            <md-button ng-click="ctrl.close()">
                                                <span translate>common.OK</span>
                                            </md-button>
                                        </md-dialog-actions>
                                    </form>
                                </md-dialog>
                            `,
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                            });
                        };
                    };
                }],
            link: function (scope, element, attrs) {
                const domElement = element[0];
                if (scope.ctrl.isStatusMessage) {
                    domElement.ondragstart = () => false;
                }
            },
            templateUrl: 'directives/message.html',
        };
    },
];
